define.alias("shared/helpers/get-in", "media/helpers/get-in");